import React from "react";

const Stat_Introduction = () => {
  return (
    <div>
      <h1>Stat Introduction</h1>
    </div>
  );
};

export default Stat_Introduction;
